
import { useState } from "react";
import { AdminUser, SortField } from "./users/types";
import { useSortUsers } from "./users/useSortUsers";
import { useUserCrud } from "./users/useUserCrud";
import { UserRole } from "@/types/strategy-types";

// Re-export the types for backward compatibility
export type { AdminUser, SortField };

export const useAdminUsers = () => {
  const [users, setUsers] = useState<AdminUser[]>([]);
  const { sortField, sortOrder, sortUsers, handleSort } = useSortUsers();
  const { loading, loadUsers, updateUserRole, updateUserName, deleteUser } = useUserCrud(setUsers, sortUsers);

  return { 
    users, 
    loading, 
    loadUsers, 
    updateUserRole, 
    updateUserName, 
    deleteUser,
    sortField,
    sortOrder,
    handleSort
  };
};
